import React from 'react';

import { formatPrice } from '@elara/client-core/lib/utils';

type TotalsByCurrency = Record<string, number>;

interface CostTotalsProps {
  totalsByCurrency: TotalsByCurrency;
  emptyLabel?: string;
  className?: string;
}

/**
 * Component for displaying cost totals grouped by currency
 * Renders formatted prices with "+" separators between multiple currencies
 */
export function CostTotals({ totalsByCurrency, emptyLabel, className }: CostTotalsProps): React.ReactNode {
  const entries = Object.entries(totalsByCurrency);

  if (entries.length === 0) {
    return emptyLabel ? <div className={className}>{emptyLabel}</div> : null;
  }

  return (
    <div className={className}>
      {entries.map(([currency, total], index) => (
        <React.Fragment key={currency}>
          <div>{formatPrice(total, currency)}</div>
          {index < entries.length - 1 && <span className="text-muted-foreground">+</span>}
        </React.Fragment>
      ))}
    </div>
  );
}
